import { useLayoutEffect, useMemo } from 'react'
import { useFeatureSwitch } from '../../../utils/features/FeatureSwitchContext'
import { FeatureSwitch } from '../../../utils/features/featureSwitches'
import { getRecommendedPriceExperimentState } from '../../../utils/features/recommendedPriceExperiment'
import { setCommonTrackingParameters } from '../../../tracking/tracking'

export function useRecommendedPriceExperimentTracking(isRecommendedPriceFlowOptionEnabled: boolean) {
  const { value: recommendedPriceFeatureValue, isLoadedFromBackend } = useFeatureSwitch(
    FeatureSwitch.PPA_12279_RECOMMENDED_PRICE_FIRST_ITERATION
  )

  const trackingParameters = useMemo(
    () =>
      getRecommendedPriceExperimentState({
        isRecommendedPriceFlowOptionEnabled,
        isRecommendedPriceFeatureLoadedFromBackend: isLoadedFromBackend,
        recommendedPriceFeatureValue,
      }).trackingParameters,
    [isRecommendedPriceFlowOptionEnabled, isLoadedFromBackend, recommendedPriceFeatureValue]
  )

  useLayoutEffect(() => {
    setCommonTrackingParameters(trackingParameters)

    return () => {
      setCommonTrackingParameters()
    }
  }, [trackingParameters])
}
